const Format = (value: number | string): string => {
  return new Intl.NumberFormat('es-CH').format(
    typeof value === 'string' ? parseInt(value) : value || 0
  )
}

export default Format
